export const regex = {
  emailValidation:
    /^(?!.*[<>])[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,10}$/,
  passwordValidation:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()_\+=\-\[\]{}\\|<>\.,\/\?'":;])[A-Za-z\d~`!@#$%^&*()_\+=\-\[\]{}\\|<>\.,\/\?'":;]{8,}/,
  numberandSpecialCharsValidation: /^[0-9*#+(),-\s]+$/,
  htmlTagValidation: /<\/?[a-z][\s\S]*>/i,
  numberOnlyValidation: /^[0-9]+$/,
  paringCodeRegex: /^[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/,
};
